import { HeadroomFinalResponse } from "@/graphql/types/graphql";
import { HeadroomTableSegment } from "./headroomTableUtils";
import { AnalysisDriverType } from "../types/types";
import { createHeadroomFinalHeaders } from "./excel/createHeaders";
import { buildHeadroomFinalRowData } from "./excel/buildRowData";
import { Cell, writeHeadroomFinalWorksheet } from "./excel/writeWorkSheet";

interface ExportHeadroomFinalDataParams {
  segments: HeadroomTableSegment[];
  driverType: string | null;
  driverMode: AnalysisDriverType;
  driverNumeratorType: string | null;
  tableName: string;
  data: HeadroomFinalResponse[] | undefined;
  sortColumn: string;
  sortDirection: "asc" | "desc";
  increasedPenetration: number;
}

/**
 * Exports headroom final data to an Excel file.
 */
export const exportHeadroomFinalDataToExcel = ({
  segments,
  driverType,
  driverMode,
  driverNumeratorType,
  tableName,
  data,
  sortColumn,
  sortDirection,
  increasedPenetration,
}: ExportHeadroomFinalDataParams): void => {
  const segmentColumns =
    segments.length === 1 || segments.some((seg) => seg.method === "MANUAL") ? 2 : 2 * segments.length;
  const driverStartColumn = segmentColumns;

  const infoHeader: Cell[] = [
    { v: `Increased Penetration: ${increasedPenetration}%`, s: { font: { bold: true } } },
    ...Array(segmentColumns + 10).fill({ v: "" }),
  ];

  const headers = createHeadroomFinalHeaders(
    segments,
    driverType,
    driverMode,
    driverNumeratorType,
    segmentColumns,
    driverStartColumn
  );

  const rowData = buildHeadroomFinalRowData(segments, data, driverMode, sortColumn, sortDirection);

  const worksheetData: (string | number | Cell)[][] = [
    infoHeader,
    ...headers,
    ...rowData.map((row) => row.map((value) => ({ v: value }))),
  ];

  writeHeadroomFinalWorksheet(worksheetData, segments, segmentColumns, driverStartColumn, tableName);
};
